class Helper {
  // Função para verificar se um CPF é válido
  static isCpfValid (cpf) {
    cpf = cpf.replace(/[^\d]+/g, '') // Remove caracteres não numéricos
    if (cpf.length !== 11) {
      return false
    }
    // Verifica se todos os dígitos são iguais (CPF inválido)
    if (/^(\d)\1+$/.test(cpf)) {
      return false
    }
    // Validação do primeiro dígito verificador
    let soma = 0
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let resto = 11 - (soma % 11)
    let digitoVerificador1 = (resto === 10 || resto === 11) ? 0 : resto
    if (digitoVerificador1 !== parseInt(cpf.charAt(9))) {
      return false
    }
    // Validação do segundo dígito verificador
    soma = 0
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i)
    }
    resto = 11 - (soma % 11)
    let digitoVerificador2 = (resto === 10 || resto === 11) ? 0 : resto
    if (digitoVerificador2 !== parseInt(cpf.charAt(10))) {
      return false
    }
    return true // CPF válido
  }

  static generateSequenciaIr0 (first, second, values) {
    let maiorNumero = 0

    if (values.length > 0) {
      values.forEach(item => {
        const sequencia = item.sequencia_ir
        const ultimoHifen = sequencia.lastIndexOf('-')
        const numero = parseInt(sequencia.substring(ultimoHifen + 1))
        if (numero > maiorNumero) {
          maiorNumero = numero
        }
      })
    }

    return `${first ? first + '-' : ''}${second}-${this.pad(++maiorNumero, 5)}`
  }

  static generateSequenciaIr (first, second, values) {
    const numeros = values.map(item => parseInt(item.sequencia_ir.split('-').pop()))
    const maiorNumero = numeros.reduce((a, b) => Math.max(a, b), 0)

    return `${first ? first + '-' : ''}${second}-${this.pad(maiorNumero + 1, 5)}`
  }

  static pad (n, width, z) {
    z = z || '0'
    n = n + ''
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
  }
}

export default Helper



// WEBPACK FOOTER //
// ./src/classes/helper.js